
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  formData: FormData,
  locale: string
};

/**
 * Export `submitRecruitmentForm`.
 */

export async function submitRecruitmentForm({ formData, locale }: Query) {
  const endpoint = getApiEndpoint('recruitmentForm');

  try {
    const { data } = await request.post(endpoint, formData, {
      headers: {
        ...acceptLanguageHeader(locale),
        'Content-Type': 'multipart/form-data'
      }
    });

    return data?.data;
  } catch (error) {
    throw handleRequestError(error);
  }
}
